import axios from "axios";
import { Loading, MessageBox, ElAlert, Message } from 'element-ui'

// 创建一个axios实例
const service_axios = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // process.env.VUE_APP_BASE_API, "http://192.168.23.70:99"
  // withCredentials: true, // 当跨域请求时发送cookie
  "Content-Type": "application/json",
  "Content-disposition": "attachment",
  timeout: 30000, // 请求超时
});

let LOADING = "";

// 请求拦截器
service_axios.interceptors.request.use(
  config => {
    LOADING = Loading.service({
      spinner: "el-icon-loading",
      text: "加载中，请稍后...",
      lock: true,
    });
    // 在发送请求之前做一些处理，例如添加token
    // const token = localStorage.getItem('token');
    // if (token) {
    //   config.headers['Authorization'] = `Bearer ${token}`;
    // }
    console.warn("查看config*****------");
    console.log(config);

    return config;
  },
  error => {
    console.log(error, "error*****");

    return Promise.reject(error);
  }
);

// 响应拦截器
service_axios.interceptors.response.use(
  response => {
    const res = response.data;

    LOADING.close();

    console.log("接口返回数据-----------");
    console.log(res);

    if (res.code !== 200) {
      console.error("接口返回错误信息：", res.message);
      if (res.msg) {
        Message({
          message: res.msg,
          type: "error",
          duration: 30 * 1000,
        });
        return res;
      } else {
        console.warn("Error");
      }
    } else {
      return res;
    }
  },
  error => {
    // if (error.response.status === 401) {
    //   // 处理未授权错误
    //   console.error('未授权，请重新登录');
    // } else {
    //   // 处理其他错误
    //   console.error('请求失败', error);
    // }

    console.error("请求失败", error);
    LOADING.close();

    if (error.response && error.response.status) {
      const statusCode = error.response.status;
      const ErrorMsg = "接口无法访问，状态代码 ：" + statusCode;

      Message({
        message: error.response.message || ErrorMsg,
        type: "error",
        duration: 30 * 1000,
      });
    } else {
      Message({
        message: "网络错误或请求超时！",
        type: "error",
        duration: 30 * 1000,
      });
    }
    return Promise.reject(error);
  }
);

export default service_axios;
